import { AuthFooter } from "../../../components/Footer/AuthFooter.jsx";
import { LoginForm } from "../../../components/Form/LoginForm";
import { RegisterForm } from "../../../components/Form/RegisterForm";
import { AuthNav, SignNav } from "../../../components/Navbar/Webpages/AuthNav";

const Register = () => {
  return (
    <div className="flex flex-col h-screen">
      <SignNav />
      <div className=" flex-grow">
        <div className="container mx-auto  max-w-screen-xl  ">
          <div className="lg:my-8 w-auto md:w-128 md:mx-auto">
            <RegisterForm />
          </div>
        </div>
      </div>

      <AuthFooter />
    </div>
  );
};

export default Register;
